import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { Redirect, Route } from "react-router-dom";
import ClientLayout from "../layouts/ClientLayout/ClientLayout";
import IntranetLayout from "../layouts/IntranetLayout/IntranetLayout";
import BasicLayout from "../layouts/BasicLayout/BasicLayout";
import STSComponent from "./STSComponent/STSComponent";
import WrappedComponent from "./WrappedComponent";


class RedirectStateScapeLegacyUrl extends STSComponent {
  componentDidMount() {
    const destination = localStorage.getItem('destination')
    if(destination){
      localStorage.removeItem('destination');
      window.location.href = JSON.parse(destination).url;
    }
  }
  render() {
    const destination = localStorage.getItem('destination')
    if (destination) {
      let url = JSON.parse(destination).url;
      return <Fragment>
      <div style={{ padding: '32px', textAlign: "center" }}>      
          <a style={{ color: '#00C', textDecoration: "underline" }} href={url}>Click here</a>&nbsp;
          if you are not redirected to your report. 
      </div>
      </Fragment>
    }else{
      return null
    }
  }
}


export class ProtectedRoute extends STSComponent {

  updateBody = (condition) => {
    if (condition) {
      document.querySelector("body").classList.remove("client-body");
      document.querySelector("body").classList.add("intranet-body");
    } else {
      document.querySelector("body").classList.remove("intranet-body");
      document.querySelector("body").classList.add("client-body");
    }
  };

  render() {
		const { authData, body, ...rest } = this.props;

    const permissions = this.props.authData 
    && this.props.authData.authData.Permissions 
    && this.props.authData.authData.Permissions ? this.props.authData.authData.Permissions : [];

    this.updateBody(permissions && permissions.includes("Intranet"));
    
    var searchParams = new URLSearchParams(rest.location.search);
    const injectedRoute = searchParams.get("route");
    const routePaths = injectedRoute ? injectedRoute.replace(/^\\+|\\+$/g, '').split("\\") : [];
    let reRoute = routePaths.pop();

    searchParams.delete("route");

    const isBasicLayout = this.props.path == "/ssignon" || reRoute == "ssignon";

    // optional destination can be established when an un-authenticated 
    // user is attempting to access legacy website resources. If a destination 
    // is established then clear the value and redirect the user to the specified URL. 
    const destination = localStorage.getItem('destination')
    if (destination){
      return <RedirectStateScapeLegacyUrl />
    }

    let component = isBasicLayout 
      ? BasicLayout 
      : permissions && permissions.includes("Intranet")
        ? IntranetLayout
        : ClientLayout;

    return authData.successLogin && authData.authData ? (
      !reRoute ? (
        <Route
          {...rest}
          // eslint-disable-next-line react/jsx-no-bind
          render={(props) => (
            <WrappedComponent component={component} body={body} {...props} />
          )}
        />
      ) : (        
        <Redirect to={"/" + reRoute + "/?" + searchParams.toString()} />
      )
    ) : isBasicLayout ? (
      reRoute == "ssignon" ? (
        <Redirect to={"/ssignon"} />
      ) : (
        <Route
        {...rest}
        // eslint-disable-next-line react/jsx-no-bind
        render={(props) => (
          <WrappedComponent component={component} body={body} {...props} />
        )}
        />    
      )

    ) 
    : (
      // unathenticated users get pushed to the sign-on page. 
      !reRoute ? (
        <Redirect to={"/login"} />
      ) : (
        reRoute.toLowerCase() == "rsignon" ? (
          <Redirect to={"/rsignon/?" + searchParams.toString()} />
        ) : (
          reRoute.toLowerCase() == "forgotpw" ? (
            <Redirect to={"/forgotpw"} />
          ) : (
            reRoute.toLowerCase() == "forgotun" ? (
              <Redirect to={"/forgotun"} />
            ) : (
              <Redirect to={"/login/?" + searchParams.toString()} />
            )            
          )          
        )
      )
    );

  }

  static propTypes = {
		cookieLogin: PropTypes.func,
    authData: PropTypes.object,
    body: PropTypes.any,
  };
}

export default ProtectedRoute;



// WEBPACK FOOTER //
// ./src/components/ProtectedRoute.js